export const GET_ALL_ORDERS = 'GET_ALL_ORDERS';
export const CLEAR_SELECTED_ORDER = 'CLEAR_SELECTED_ORDER';
export const CLEAR_ACTIVE_DELIVERY_ORDER = 'CLEAR_ACTIVE_DELIVERY_ORDER';
export const UPDATE_SELECTED_ORDER = 'UPDATE_SELECTED_ORDER';
export const SET_ACTIVE_ORDER_MODAL_DIMENSIONS = 'SET_ACTIVE_ORDER_MODAL_DIMENSIONS';


export const GET_ALL_DRIVERS = 'GET_ALL_DRIVERS';
export const UPDATE_HIGHLIGHTED_DRIVER = 'UPDATE_HIGHLIGHTED_DRIVER';
export const CLEAR_HIGHLIGHTED_DRIVER = 'CLEAR_HIGHLIGHTED_DRIVER';
export const UPDATE_DRIVERS = 'UPDATE_DRIVERS';
export const UPDATE_DRIVER_FILTER = 'UPDATE_DRIVER_FILTER';

export const GET_STORE_DATA = 'GET_STORE_DATA';
export const RESET_STATISTICS = 'RESET_STATISTICS';
export const REMOVE_ALARM = "REMOVE_ALARM";

export const GET_ALL_SCHEDULED = 'GET_ALL_SCHEDULED';
export const ACTION_SCHEDULED_FASTFORWARD = 'ACTION_SCHEDULED_FASTFORWARD';
export const ACTION_SCHEDULED_CONFIRMATION = 'ACTION_SCHEDULED_CONFIRMATION';
export const UPDATE_SCHEDULED_ORDERS = 'UPDATE_SCHEDULED_ORDERS';
export const ACTION_SCHEDULED_CLEAN = 'ACTION_SCHEDULED_CLEAN';

export const CREATE_SESSION = 'CREATE_SESSION';
export const CLOSE_SESSION = 'CLOSE_SESSION';
